let csvw_url = "https://www.csvw.com";

let workspace50 = [
  {
    imgurl: "/u/cms/www/202110/0920035850O5.png",
    imgurlMobile: "/u/cms/www/202110/092018031032.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200357cyu6.png",
    imgurlMobile: "/u/cms/www/202110/092018033BOa.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200357X0X0.png",
    imgurlMobile: "/u/cms/www/202110/09201804eQv0.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920040075tF.png",
    imgurlMobile: "/u/cms/www/202110/09201806bjv7.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200359PB5K.png",
    imgurlMobile: "/u/cms/www/202110/092018061ex7.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200400q8Au.png",
    imgurlMobile: "/u/cms/www/202110/09201809b246.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200402h276.png",
    imgurlMobile: "/u/cms/www/202110/092018137UA2.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920040137c9.png",
    imgurlMobile: "/u/cms/www/202110/09201812eA14.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092004010S6F.png",
    imgurlMobile: "/u/cms/www/202110/092018117f5j.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092004033409.png",
    imgurlMobile: "/u/cms/www/202110/092018151d2S.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200403giG3.png",
    imgurlMobile: "/u/cms/www/202110/09201814oGOn.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09200403LK9x.png",
  //   imgurlMobile: "/u/cms/www/202110/092018167YIC.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09200404sn20.png",
    imgurlMobile: "/u/cms/www/202110/09201816AiYG.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092004042bLK.png",
    imgurlMobile: "/u/cms/www/202110/09201817GZz3.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200404bGWX.png",
    imgurlMobile: "/u/cms/www/202110/092018197ZXU.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09200405Uqym.png",
    imgurlMobile: "/u/cms/www/202110/092018194594.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace51 = [
  // {
  //   imgurl: "/u/cms/www/202110/09203129H77M.png",
  //   imgurlMobile: "/u/cms/www/202110/09203830tb4s.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092031299h16.png",
  //   imgurlMobile: "/u/cms/www/202110/092038317u19.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09203131Zys3.png",
  //   imgurlMobile: "/u/cms/www/202110/092038322794.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/0920313408Ao.png",
    imgurlMobile: "/u/cms/www/202110/09203834V01V.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/092031311227.png",
  //   imgurlMobile: "/u/cms/www/202110/09203832N87T.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/092031322S5b.png",
    imgurlMobile: "/u/cms/www/202110/0920383570V9.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09203134935W.png",
    imgurlMobile: "/u/cms/www/202110/092038358830.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09203133190z.png",
    imgurlMobile: "/u/cms/www/202110/09203835k759.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/0920313512F0.png",
    imgurlMobile: "/u/cms/www/202110/09203837rueM.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092031379Oo8.png",
    imgurlMobile: "/u/cms/www/202110/09203836952p.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09203136n73j.png",
    imgurlMobile: "/u/cms/www/202110/09203837w053.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace52 = [
  {
    imgurl: "/u/cms/www/202110/092055290L4G.png",
    imgurlMobile: "/u/cms/www/202110/09210835Q006.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092055294v00.png",
    imgurlMobile: "/u/cms/www/202110/0921083552b5.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/092055290852.png",
  //   imgurlMobile: "/u/cms/www/202110/09210835NW8k.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092055310y3Q.png",
  //   imgurlMobile: "/u/cms/www/202110/09210836U9i4.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09205532U433.png",
    imgurlMobile: "/u/cms/www/202110/09210836o7z5.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09205532344J.png",
    imgurlMobile: "/u/cms/www/202110/09210836237Z.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092055323d3i.png",
    imgurlMobile: "/u/cms/www/202110/09210837G7A7.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09205534i3UD.png",
  //   imgurlMobile: "/u/cms/www/202110/09210838XZ10.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09205536CEC3.png",
  //   imgurlMobile: "/u/cms/www/202110/09210838ai00.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09205535K4aj.png",
    imgurlMobile: "/u/cms/www/202110/09210838m2I0.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09205535qdG4.png",
    imgurlMobile: "/u/cms/www/202110/09210838Oeq9.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09205537461E.png",
  //   imgurlMobile: "/u/cms/www/202110/092108399298.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09205537Ygcs.png",
    imgurlMobile: "/u/cms/www/202110/09210839y84u.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09205538zjI4.png",
    imgurlMobile: "/u/cms/www/202110/0921083943q8.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09205538r9uz.png",
    imgurlMobile: "/u/cms/www/202110/09210840o7y1.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09205539J1GO.png",
  //   imgurlMobile: "/u/cms/www/202110/09210840s4oo.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/092055436u6h.png",
    imgurlMobile: "/u/cms/www/202110/09210841482B.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09205539834D.png",
    imgurlMobile: "/u/cms/www/202110/09210840551s.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09205540AbS6.png",
  //   imgurlMobile: "/u/cms/www/202110/09210841UjB5.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09205543367k.png",
    imgurlMobile: "/u/cms/www/202110/092108431p3i.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace53 = [
  // {
  //   imgurl: "/u/cms/www/202110/1216433562aQ.png",
  //   imgurlMobile: "/u/cms/www/202110/09213157866l.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/121645003c70.png",
  //   imgurlMobile: "/u/cms/www/202110/09213205G7sM.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/12164517hE2G.png",
    imgurlMobile: "/u/cms/www/202110/092131575ml6.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/1216453409X4.png",
    imgurlMobile: "/u/cms/www/202110/09213205d296.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/121645521Y8S.png",
    imgurlMobile: "/u/cms/www/202110/09213158b46H.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/12164611tmz2.png",
  //   imgurlMobile: "/u/cms/www/202110/09213206UokN.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/1216462897l4.png",
    imgurlMobile: "/u/cms/www/202110/0921320694CB.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/12164645X5mH.png",
    imgurlMobile: "/u/cms/www/202110/09213212r3E1.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/12164704K349.png",
    imgurlMobile: "/u/cms/www/202110/09213207636k.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/12164723O3i0.png",
  //   imgurlMobile: "/u/cms/www/202110/09213208X145.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/12164740Vc10.png",
    imgurlMobile: "/u/cms/www/202110/09213209452b.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/12164806laWB.png",
    imgurlMobile: "/u/cms/www/202110/09213209GF2r.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/121648237P75.png",
    imgurlMobile: "/u/cms/www/202110/092132106k86.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/121648395e24.png",
    imgurlMobile: "/u/cms/www/202110/092132104IUE.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/12164857sWTm.png",
    imgurlMobile: "/u/cms/www/202110/092132113h5D.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/121649154g0G.png",
    imgurlMobile: "/u/cms/www/202110/09213212OVKO.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/12164937Pg0L.png",
  //   imgurlMobile: "/u/cms/www/202110/09213212jk24.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/1216495495ML.png",
  //   imgurlMobile: "/u/cms/www/202110/09213214GlNS.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/121650118A8c.png",
    imgurlMobile: "/u/cms/www/202110/092132150prV.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/1216502991O0.png",
    imgurlMobile: "/u/cms/www/202110/09213215LcN0.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace54 = [
  // {
  //   imgurl: "/u/cms/www/202110/15203215Zyy4.png",
  //   imgurlMobile: "/u/cms/www/202110/152048216039.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/15203347621d.png",
  //   imgurlMobile: "/u/cms/www/202110/15204842ms32.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/152034169Aw4.png",
  //   imgurlMobile: "/u/cms/www/202110/15204903cB73.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/152034372524.png",
  //   imgurlMobile: "/u/cms/www/202110/15204923030E.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/15203505J5xZ.png",
    imgurlMobile: "/u/cms/www/202110/152049438x3C.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15203527p7C9.png",
    imgurlMobile: "/u/cms/www/202110/15204959oc8w.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/152035472R8K.png",
    imgurlMobile: "/u/cms/www/202110/15205016lTTg.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15203606Vzc3.png",
    imgurlMobile: "/u/cms/www/202110/15205032953V.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/1520363314o4.png",
    imgurlMobile: "/u/cms/www/202110/15205050Z12V.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15203654000q.png",
    imgurlMobile: "/u/cms/www/202110/15205109Z45z.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15203717Q353.png",
    imgurlMobile: "/u/cms/www/202110/15205139Aw91.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204033IJ5P.png",
    imgurlMobile: "/u/cms/www/202110/15205200734v.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204214n3st.png",
    imgurlMobile: "/u/cms/www/202110/15205217q001.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204237xN9F.png",
    imgurlMobile: "/u/cms/www/202110/15205234vXG4.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204256n6G6.png",
    imgurlMobile: "/u/cms/www/202110/15205251VN8T.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204316254D.png",
    imgurlMobile: "/u/cms/www/202110/15205308688n.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204339g8zQ.png",
    imgurlMobile: "/u/cms/www/202110/152053288h79.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/15204403vTF5.png",
  //   imgurlMobile: "/u/cms/www/202110/15205347a1Z0.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/15204546RczH.png",
    imgurlMobile: "/u/cms/www/202110/15205426Ia4b.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/15204628286q.png",
    imgurlMobile: "/u/cms/www/202110/15205444pb1b.jpg",
  },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let template60 = [
  // {
  //   imgurl: "/u/cms/www/202110/092131361QAv.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151316r00.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131365n31.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215131oDIK.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213136D7j4.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215131k6ow.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/0921313616wb.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151325QS8.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131378vW5.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151334w13.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131382EF6.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215135A14B.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213139371r.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151352798.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131396Up1.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215136s149.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/0921313935KS.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215137215X.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213140D7Ly.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215136E076.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213140i4yo.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215137k545.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213141ApLM.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215137J404.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131408g4f.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215139sCa3.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131412nR0.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151382cK8.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131412706.jpg",
  //   imgurlMobile: "/u/cms/www/202110/0921513316vQ.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213142OV8o.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151401wVR.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/0921314133n9.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151390817.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/0921314296OM.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151408p3v.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131420thE.jpg",
  //   imgurlMobile: "/u/cms/www/202110/0921514161zW.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213143D2ha.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151420707.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/09213143h40D.jpg",
    imgurlMobile: "/u/cms/www/202110/0921514135wH.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213143801m.jpg",
    imgurlMobile: "/u/cms/www/202110/09215143p33T.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092131441a3Z.jpg",
    imgurlMobile: "/u/cms/www/202110/092151430GEL.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213144cg80.jpg",
    imgurlMobile: "/u/cms/www/202110/09215144Nrdk.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092131453mjH.jpg",
    imgurlMobile: "/u/cms/www/202110/09215143I42n.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213145gmS9.jpg",
    imgurlMobile: "/u/cms/www/202110/09215145Suy7.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213145QGpK.jpg",
    imgurlMobile: "/u/cms/www/202110/09215145746r.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213145Y5p2.jpg",
    imgurlMobile: "/u/cms/www/202110/0921514901u2.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/092131461vA2.jpg",
    imgurlMobile: "/u/cms/www/202110/092151467930.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213147gD43.jpg",
    imgurlMobile: "/u/cms/www/202110/0921514791qP.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/09213148a2q9.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151471uw9.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131489ct5.jpg",
  //   imgurlMobile: "/u/cms/www/202110/0921514882T9.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/0921314706kQ.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151480uII.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131479V30.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215148F3a8.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131489j7t.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215149f0nF.jpg",
  // },
  {
    imgurl: "/u/cms/www/202110/092131499Y67.jpg",
    imgurlMobile: "/u/cms/www/202110/0921515257kD.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213149NQ42.jpg",
    imgurlMobile: "/u/cms/www/202110/092151505P8n.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213149KY1L.jpg",
    imgurlMobile: "/u/cms/www/202110/092151500jE9.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213150788w.jpg",
    imgurlMobile: "/u/cms/www/202110/09215151Uf82.jpg",
  },
  {
    imgurl: "/u/cms/www/202110/09213150r393.jpg",
    imgurlMobile: "/u/cms/www/202110/092151530xMn.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202110/092131506F27.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215153C8I0.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/09213151o1TR.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215153dN26.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/0921315162S0.jpg",
  //   imgurlMobile: "/u/cms/www/202110/092151546Z29.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131518s5T.jpg",
  //   imgurlMobile: "/u/cms/www/202110/0921515439zg.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202110/092131523fQd.jpg",
  //   imgurlMobile: "/u/cms/www/202110/09215154Rzu2.jpg",
  // },
].map((item) => {
  return {
    imgurl: `${csvw_url}${item.imgurl}`,
    imgurlMobile: `${csvw_url}${item.imgurlMobile}`,
  };
});

let workspace60 = [];
let workspace60big = [];
let workspace60bigMobile = [];
for (let i = 0; i < 3; i++) {
  let arr = [];
  for (let j = 0; j < 5; j++) {
    let element = `${template60[i * 5 + j].imgurl}`;
    let elementbig = `${template60[i * 5 + j].imgurlMobile}`;
    arr.push(element);
    workspace60big.push(element);
    workspace60bigMobile.push(elementbig);
  }
  workspace60.push(arr);
}

export default {
  // 列表车型
  workspace5: [
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203088Pv7.png`,
      title: "ID.Store X北京旗舰店开业",
      content:
        "上汽大众数字化城市展厅ID. Store X北京旗舰店在北京SOLANA蓝色港湾正式开业，新店延续了ID. Store X的设计理念，拥有丰富的数字化设施，展厅处处体现北京千年历史古建筑与现代文明新视觉的交融。同时，品质乐趣纯电跨界车ID.3也首次在ID. Store X揭幕展示，现场还举行了车主交车仪式。北京ID. Store X的开业进一步完善了大众品牌2021年建设新能源城市展厅的布局。",
      imgurl: [],
      imgurl2: workspace50.map((item) => item.imgurl),
      imgurlMobile: [],
      imgurlMobile2: workspace50.map((item) => item.imgurlMobile),
      videourl: [],
      url:
        "https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=3149",
    },
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203081v80.png`,
      title: "ID.Store上海静安大悦城开业",
      content:
        "上汽大众城市展厅ID. Store上海静安大悦城店开业。展厅集品牌体验、网红打卡、产品展示、集客销售等功能于一体，秉承年轻、效率和时尚的设计理念，为消费者营造便捷、温馨的展厅体验，同时更好地感受到上汽大众的人、车、生活理念，以新零售业态触达更多消费者。",
      // imgurl: [`${csvw_url}/u/cms/www/202110/151926579D8d.png`],
      imgurl: [],
      imgurl2: workspace51.map((item) => item.imgurl),
      imgurlMobile: [`${csvw_url}/u/cms/www/202110/1519385357y1.jpg`],
      imgurlMobile2: workspace51.map((item) => item.imgurlMobile),
      videourl: [`${csvw_url}/u/cms/www/202110/091756559Mp9.mp4`],
      url: "https://mp.weixin.qq.com/s/XDvLHwCzb8LiX91RrvMa6Q",
    },
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203081v80.png`,
      title: "ID.Store上海新达汇·三林店开业",
      content:
        "上汽大众城市展厅ID. Store上海浦东店开业。展厅集品牌体验、网红打卡、产品展示、集客销售等功能于一体，秉承年轻、效率和时尚的设计理念，色彩绚丽的发光吊顶，以律动潮流设计唤醒消费者的感官，舒适的休息区域为消费者营造便捷、温馨的体验，以新零售业态触达更多消费者。",
      // imgurl: [`${csvw_url}/u/cms/www/202110/09212324X8ew.png`],
      imgurl: [],
      imgurl2: workspace52.map((item) => item.imgurl),
      imgurlMobile: [`${csvw_url}/u/cms/www/202110/09212713mt3H.jpg`],
      imgurlMobile2: workspace52.map((item) => item.imgurlMobile),
      videourl: [`${csvw_url}/u/cms/www/202110/091756577jo9.mp4`],
      url: "https://mp.weixin.qq.com/s/V4FHCN4qTRwBycLFxz9XEg",
    },
    {
      iconurl: `${csvw_url}/u/cms/www/202109/301203081v80.png`,
      title: "ID.Store上海徐汇绿地缤纷城店开业",
      content:
        "上汽大众城市展厅ID. Store上海徐汇绿地缤纷城店开业。展厅集品牌体验、网红打卡、产品展示、集客销售等功能于一体，以洁净的白色作为主色调，结合木质质感，通过极简的设计手法，创造出前卫时尚空间，营造便捷、温馨的展厅体验，以新零售业态触达更多消费者。",
      // imgurl: [`${csvw_url}/u/cms/www/202110/15194127BFc0.png`],
      imgurl: [],
      imgurl2: workspace54.map((item) => item.imgurl),
      imgurlMobile: [`${csvw_url}/u/cms/www/202110/151941069939.jpg`],
      imgurlMobile2: workspace54.map((item) => item.imgurlMobile),
      videourl: [`${csvw_url}/u/cms/www/202110/15185456V670.mp4`],
      url: "https://mp.weixin.qq.com/s/IXEr5GIqiISz8zz0qUj_Rw",
    },
    {
      iconurl: `${csvw_url}/u/cms/www/202109/30120308PI20.png`,
      title: "ID.Store南京吾悦店开业",
      content:
        "上汽大众城市展厅ID. Store南京吾悦店开业。在苏舜汽车吾悦广场上汽大众展厅，纯电动ID.4 X、ID.6 X、ID.3等车型吸引了很多人的目光。作为2021南京公益周“南京，我想对你说——”爱心活动的合作单位，上汽大众不仅始终以严谨的态度致力于疫情防控，更以长远的目光投入到自然生态的各项保护工作中，为人们创造安全舒适、智能便捷、低碳环保的出行环境。",
      imgurl: [],
      imgurl2: workspace53.map((item) => item.imgurl),
      imgurlMobile: [],
      imgurlMobile2: workspace53.map((item) => item.imgurlMobile),
      videourl: [],
      url: "",
    },
  ],
  // 现场花絮
  workspace6: [
    {
      title: "3号馆",
      key: "workspace60",
    },
  ],
  workspace60: workspace60,
  workspace60big: workspace60big,
  workspace60bigMobile: workspace60bigMobile,
};
